import { Box, BoxProps, Image, chakra } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import styles from "./Footer.module.css";
import instagram from "./images/instagram.png";
import dayjs from "dayjs";

interface FooterProps extends BoxProps {
  copyrightContainerProps?: BoxProps;
}

export const Footer = ({ copyrightContainerProps, ...props }: FooterProps) => {
  return (
    <Box backgroundColor="bg.canvas" {...props}>
      <Box display="flex" className={styles.footerLinks}>
        <Box>
          <Link style={{ display: "block", padding: "0.75rem 0" }} to="/">
            ABOUT
          </Link>
          <Link
            style={{ display: "block", padding: "0.75rem 0" }}
            to="/contact"
          >
            CONTACT
          </Link>
          <Link style={{ display: "block", padding: "0.75rem 0" }} to="/faq">
            FAQ
          </Link>
        </Box>
        <Box>
          <Link
            style={{ display: "block", padding: "0.75rem 0" }}
            to="/policy/privacy"
          >
            PRIVACY POLICY
          </Link>
          <Link
            style={{ display: "block", padding: "0.75rem 0" }}
            to="/policy/refunds"
          >
            REFUND POLICY
          </Link>
        </Box>
      </Box>
      <Box
        backgroundColor="brand.green.light"
        borderTop="1px solid"
        borderColor="brand.green.dark"
        paddingY="2rem"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        {...(copyrightContainerProps || {})}
      >
        <chakra.a href="https://www.instagram.com/greenflagdate/" display="block">
          <Image src={instagram} width="1.25rem" alt="Instagram" />
        </chakra.a>
        <Box>&copy; Green Flag Date LLC 2024-{dayjs().year()}</Box>
      </Box>
    </Box>
  );
};
